// db/errors.ts
import { BaseError } from "@adornis/validation/errors/BaseError.js";
var NoPermissionError = class extends BaseError {
  constructor(extensions) {
    if (!extensions.translationKey)
      extensions.translationKey = "users.not_authorized";
    super(
      `Permission '${extensions.permission}' not granted${extensions.context ? ` for '${extensions.context}'` : ""}`,
      extensions
    );
  }
  static createFromDetails(message, extensions) {
    return new this(extensions);
  }
};
var GenerallyUnauthorizedError = class extends BaseError {
  constructor() {
    super(`You are not authorized to perform this action`, { translationKey: "users.not_authorized" });
  }
};
var NotLoggedInError = class extends BaseError {
  constructor() {
    super(`You are not logged in`, { translationKey: "users.not_logged_in" });
  }
};
var InvalidUserIDError = class extends BaseError {
  constructor() {
    super(`Invalid user ID`, { translationKey: "users.invalid_user_id" });
  }
};
var InvalidTokenError = class extends BaseError {
  constructor() {
    super(`Invalid token`, { translationKey: "users.invalid_token" });
  }
};
export {
  GenerallyUnauthorizedError,
  InvalidTokenError,
  InvalidUserIDError,
  NoPermissionError,
  NotLoggedInError
};
